import React, { useEffect, useState } from "react";
import SiteLayout from "../components/layout/SiteLayout";
import { api } from "../lib/api";
import { useSettings } from "../lib/settings";
import { Calendar, MapPin } from "lucide-react";

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const { settings } = useSettings();
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  return (
    <SiteLayout>
      <section className="container-x py-20 lg:py-28">
        <div className="eyebrow mb-4">{settings.events_eyebrow}</div>
        <h1 className="display text-5xl lg:text-7xl">{settings.events_headline}</h1>
        <p className="mt-6 max-w-2xl text-[hsl(var(--ink-muted))] leading-relaxed">
          {settings.events_intro}
        </p>
      </section>

      <section data-testid="events-list" className="container-x pb-28">
        <div className="rule" />
        {events.map((e) => (
          <div
            key={e.id}
            data-testid={`event-${e.id}`}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-b border-[hsl(var(--line))]"
          >
            <div className="md:col-span-3">
              <div className="display text-4xl">
                {new Date(e.date).toLocaleDateString(undefined, { day: "2-digit" })}
              </div>
              <div className="eyebrow mt-1">
                {new Date(e.date).toLocaleDateString(undefined, { month: "long", year: "numeric" })}
              </div>
            </div>
            <div className="md:col-span-6">
              <div className="display text-2xl lg:text-3xl">{e.title}</div>
              <p className="mt-3 text-sm text-[hsl(var(--ink-muted))] leading-relaxed">{e.description}</p>
            </div>
            <div className="md:col-span-3 space-y-2 text-sm">
              <div className="flex items-center gap-2 text-[hsl(var(--ink))]">
                <Calendar size={14} /> {e.time}
              </div>
              <div className="flex items-center gap-2 text-[hsl(var(--ink-muted))]">
                <MapPin size={14} /> {e.location}
              </div>
            </div>
          </div>
        ))}
        {!events.length && (
          <div className="py-12 text-[hsl(var(--ink-muted))] text-sm">No upcoming events yet. Check back soon.</div>
        )}
      </section>
    </SiteLayout>
  );
}
